import {
  Analytics as BaseAnalytics,
  ConverterAnalitycsEventType,
} from '@quicktools/shared-components';

import { HOTJAR_ID, TOOL_NAME, TRACKING_ID, TRACKING_ID_4, VERSION } from '../../configs';

const page_name = 'main';

const TOOL_MAP: { [key: string]: string } = {
  em: 'emojis',
  sy: 'symbols',
  fg: 'font_generator',
};

class Analytics extends BaseAnalytics {
  event(action: string) {
    this.gaEvent(action, {
      page_name,
    });
    this.hjEvent(action);
  }

  pageOpen() {
    this.gaEvent(ConverterAnalitycsEventType.PAGE_OPEN, {
      page_name,
      non_interaction: true,
    });
  }

  textBoxClick() {
    this.event('text_box_click');
  }

  textBoxType() {
    this.event('text_box_type');
  }

  symbolCopy(category_name: string, symbol_name: string) {
    this.gaEvent('symbol_copy', {
      page_name,
      category_name,
      symbol_name,
    });
  }

  symbolArrayCopy() {
    this.event('symbol_array_copy');
  }

  symbolArrayClear() {
    this.event('symbol_array_clear');
  }

  filterOpen() {
    this.event('filter_open');
  }

  filterApply() {
    this.event('filter_apply');
  }

  toggleClick(name: string) {
    this.gaEvent('toggle_click', {
      page_name,
      destination: TOOL_MAP[name],
    });
  }
}

export default new Analytics({
  HOTJAR_ID,
  TOOL_NAME,
  TRACKING_ID,
  TRACKING_ID_4,
  VERSION,
});
